import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "koine_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((c) => {
  const t = getToken();
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export const emitGuard = (detail) => window.dispatchEvent(new CustomEvent("koine-guard", { detail }));
api.interceptors.response.use(undefined, (e) => {
  const d = e?.response?.data?.detail;
  if (d && typeof d === "object" && d.guard) emitGuard({ message: d.msg, field: d.field, reason: d.reason || d.screening?.reason, strikes: d.strikes, blocked: d.blocked });
  return Promise.reject(e);
});

export const wsUrl = (path) => `${API.replace(/^http/, "ws")}${path}?token=${encodeURIComponent(getToken() || "")}`;

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Algo deu errado. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (detail.guard) return "Envio bloqueado pelo Guarda-Costas IA";
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return detail.msg || String(detail);
}

export const CATEGORIES = {
  jovens: "Jovens",
  estudos: "Estudos Bíblicos",
  musica: "Música & Hobbies",
  conversa: "Roda de Conversa",
};

export const TABS = [
  { key: "all", label: "Para Você", testid: "nav-tab-para-voce" },
  { key: "jovens", label: "Jovens", testid: "nav-tab-jovens" },
  { key: "estudos", label: "Estudos Bíblicos", testid: "nav-tab-estudos-biblicos" },
  { key: "musica", label: "Música & Hobbies", testid: "nav-tab-musica-hobbies" },
  { key: "institutions", label: "Instituições", testid: "nav-tab-instituicoes" },
];

export const formatCount = (n) => (n >= 1000 ? `${(n / 1000).toFixed(1)}k` : String(n ?? 0));
